module.exports = __webpack_public_path__ + "media/gundula3.c22a60c7.mp3";